<!-- <ion-toolbar [color]="'none'">
    <ion-title>
        {{title | titlecase }}
    </ion-title>
    <ion-buttons slot="end">
        <ion-button  [fill]="'clear'" (click)="doCancel(null)">
            <ion-icon name="close"  ></ion-icon>
        </ion-button>
    </ion-buttons>
</ion-toolbar> -->
<div class="inner-content" padding="">
  <div *ngIf="!platform.is('mobile')" class="modal-close-btn">
    <ion-icon name="close" (click)="closeModal()"></ion-icon>
  </div>
  <div text-center class="ion-margin-top">
    <div>
      {{ title | titlecase }} <strong>#{{ formattedId }}</strong>
    </div>
    <div style="font-size: 12px; color: #5b7583">Please select a reason</div>
  </div>
  <ion-list class="cancel-reasons-section">
    <ion-radio-group>
      <ion-item
        [lines]="'none'"
        *ngFor="let reason of reasons; let i = index"
        (click)="
          cancelReason = reason?.title === 'Other' ? '' : reason.title;
          otherReason = reason?.title === 'Other'
        "
      >
        <ion-label font-size-12>{{ reason?.title }}</ion-label>
        <ion-radio
          mode="ios"
          color="light"
          slot="end"
          value="{{ reason?.title }}"
        ></ion-radio>
      </ion-item>
      <!--<ion-item [lines]="'none'" (click)="(otherReason = true ) && (cancelReason = '')" >
                <ion-label font-size-12 >Others</ion-label> 
                <ion-radio mode="ios" color="light" slot="end" value=''></ion-radio>
            </ion-item>-->
      <ion-item *ngIf="otherReason">
        <ion-textarea
          [rows]="1"
          [(ngModel)]="cancelReason"
          [placeholder]="'Specify reason...'"
        ></ion-textarea>
      </ion-item>
    </ion-radio-group>
  </ion-list>
</div>
<ion-footer>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-button
          [color]="'primary'"
          size="large"
          expand="block"
          [disabled]="cancelReason?.length <= 0"
          (click)="doCancel(cancelReason)"
          >Done</ion-button
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
